import { render, staticRenderFns } from "./messagePage.vue?vue&type=template&id=00bceec8&scoped=true&"
import script from "./messagePage.vue?vue&type=script&lang=js&"
export * from "./messagePage.vue?vue&type=script&lang=js&"
import style0 from "./messagePage.vue?vue&type=style&index=0&id=00bceec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bceec8",
  null
  
)

export default component.exports